import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import FormHelperText from "@mui/material/FormHelperText";

export const CloneOptionsBox = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(3)
}));

export const HelperText = styled(FormHelperText)(({ theme }) => ({
    marginLeft: "14px"
}));
